import React from "react";
import makeTimelineFromSegment from "../../../store/selectors/timelineFromSegment.js";
import { TimelineSegment } from "./components/TimelineSegment.js";
import { getSelectedBounds } from "../RebookFlow/utils/getSelectedBounds.js";
import { getOrderUtils } from "../../../utils/getOrderUtils.js";
import { useI18n, t } from "@bookingcom/lingojs-react";
const Timeline = ({ segments, isDdotCnpCondensed, hideCabinClassMismatch }) => {
    const timelinedSegments = segments.map((segment, segmentIndex) => {
        return makeTimelineFromSegment(segment, segmentIndex);
    });
    return (React.createElement("div", null, timelinedSegments.map((segment, i) => (React.createElement(React.Fragment, { key: i },
        React.createElement(TimelineSegment, { segment: segment, segmentIndex: i, hideCabinClassMismatch: hideCabinClassMismatch, hideHeading: isDdotCnpCondensed }))))));
};
export const RebookTimeline = ({ segments, isDdotCnpCondensed, hideCabinClassMismatch, order }) => {
    const i18n = useI18n();
    const timelinedSegments = segments.map((segment, segmentIndex) => {
        return makeTimelineFromSegment(segment, segmentIndex);
    });
    const { isRoundTrip } = getOrderUtils(order);
    const selectedBounds = getSelectedBounds();
    const hasSingleBoundSelected = isRoundTrip && selectedBounds && selectedBounds.length === 1;
    return (React.createElement("div", null, timelinedSegments.map((segment, segmentIndex) => (React.createElement(React.Fragment, { key: segmentIndex },
        React.createElement(TimelineSegment, { segment: segment, segmentIndex: segmentIndex, hideCabinClassMismatch: hideCabinClassMismatch, hideHeading: isDdotCnpCondensed, headerBadgeProps: hasSingleBoundSelected
                ? segmentIndex === selectedBounds[0]
                    ? {
                        text: i18n.trans(t("flights_pb_rebook_bound_selection_badge_new")),
                        variant: "callout",
                        alternative: true
                    }
                    : {
                        text: i18n.trans(t("flights_pb_rebook_bound_selection_badge_no_change")),
                        alternative: true
                    }
                : undefined }))))));
};
export default Timeline;
